import type { BillingPlan } from '@recruitee/products-types';

export const getProductSafeSlotsCount = (
  product: BillingPlan,
  {
    slotsTotal,
    jobSlotsUsed,
  }: {
    slotsTotal: number;
    jobSlotsUsed: number;
  },
) => Math.max(product.baseSlots, Number.isFinite(slotsTotal) ? slotsTotal : jobSlotsUsed);
